import React from 'react';
import {FormattedMessage} from "react-intl";

// import { basePath } from "../../core/assets";
import Analytics from './../../../../analytics';
import {UserPopupTypes} from "../../constants";

const FeatureWizardBodyItem = (props) => {
  return props.isMobile ? (
    <li className="menu-list__item">
      <div className={"menu-list__item-feature"
      + (props.isActive ? " active" : "")
      // + (props.currentFeature.matchesMetaFailed ? " menu-list__item-feature--disabled" : "")
      + (props.backGroundSizeCover ? " menu-list__item-feature--stone" : "")
      + (props.disabled ? " menu-list__item-feature--not-available" : "")}
           onClick={() => (props.disabled && !props.itemIsLocked)
             ? props.onItemClickDisabled(props.currentFilterValue, props.itemIsLocked, props.currentStep.filterName)
             : props.onItemClick(props.currentFilterValue, props.itemIsLocked, props.currentStep.filterName)}
           style={props.styles}>
        <div className={"menu-list__item-feature-text" + (props.isPulsating ? " feature-text--pulsating" : "")}>
          {props.itemIsLocked
            ? <span className="menu-list__item-feature-text-price menu-list__item-feature-text-price--locked"/>
            : <span className="menu-list__item-feature-text-name">{props.currentFilterValue.displayText}</span>}
        </div>
      </div>
      {props.isActive && (props.itemIsLocked || (!props.userIsLoggedIn && props.getQuoteEnabled)) ? (
        <div className="menu-list__item-buttons">
          <button className="menu-list__item-buttons__unlock ui-button2 ui-button2--green"
                  onClick={() =>
                    Analytics.sendClickEvent('show-wizard-login-' + props.currentFilterValue.displayText)
                    && props.handleUserLoginClick(
                      props.getQuoteEnabled ? UserPopupTypes.GetQuote : UserPopupTypes.Unlock
                    )}>
            <FormattedMessage id={props.getQuoteEnabled
              ? "filterSelection.wizard.feature.getQuote"
              : "filterSelection.wizard.feature.unlock"}/>
          </button>
        </div>
      ) : null}
    </li>
  ) : (
    <div className={"feature" + (props.isActive ? " active" : "")
    + (props.backGroundSizeCover ? " feature--stone " + props.currentStep.filterName.replace(/ /g,"").toLowerCase() : "")
    + (props.disabled ? " menu-list__item-feature--not-available" : "")}
         style={props.styles}
         onClick={() => (props.disabled && !props.itemIsLocked)
           ? props.onItemClickDisabled(props.currentFilterValue, props.itemIsLocked, props.currentStep.filterName)
           : props.onItemClick(props.currentFilterValue, props.itemIsLocked, props.currentStep.filterName)}>
      {props.isActive && (props.itemIsLocked || (!props.userIsLoggedIn && props.getQuoteEnabled)) ? (
        <div className="feature-buttons">
          <button className={"feature-buttons__unlock ui-button2 ui-button2--green"
          + (props.getQuoteEnabled ? " ui-button2--getquote" : "")}
                  onClick={() =>
                    Analytics.sendClickEvent((props.getQuoteEnabled ? 'show-wizard-get-quote-' : 'show-wizard-login-') + props.currentFilterValue.displayText)
                    && props.handleUserLoginClick(
                      props.getQuoteEnabled ? UserPopupTypes.GetQuote : UserPopupTypes.Unlock
                    )}>
            <FormattedMessage id={props.getQuoteEnabled
              ? "filterSelection.wizard.feature.getQuote"
              : "filterSelection.wizard.feature.unlock"}/>
          </button>
        </div>
      ) : null}
      <div className={"feature-text" + (props.itemIsLocked ? " feature-text--locked" : " feature-text--unlocked")
      + (props.isPulsating ? " feature-text--pulsating" : "")}>
        {props.itemIsLocked ? null : (
          <span className="feature-text__name">{props.currentFilterValue.displayText}</span>
        )}
      </div>
    </div>
  )
};

FeatureWizardBodyItem.displayName = 'FeatureWizardBodyItem';

export default FeatureWizardBodyItem;
